import { getURLParams } from 'src/helpers/actions/local/core/local_action_parse_url_helpers';
import {
	CAMERA_DURATION_MAX,
	CAMERA_DURATION_MIN,
} from 'src/helpers/actions/local/devices/camera_local_actions';
//Types
import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';

export const validateCameraURLWebhook = (url: string): ActionJob | null => {
	const action: ActionJob = getURLParams(url);
	const config = action.params?.config;
	if (action.method === 'camera.startrecording' && action.params?.duration != null) {
		const duration = action.params.duration;
		action.error =
			action.error ||
			!Number.isSafeInteger(duration) ||
			duration < CAMERA_DURATION_MIN ||
			duration > CAMERA_DURATION_MAX;
	} else if (action.method === 'camera.setconfig') {
		action.error = action.error || !config || (config?.arm == null && config?.privacy == null);
	} else if (action.method === 'camerazone.setconfig') {
		action.error = action.error || action.params?.id == null || !config || config?.enable == null;
	}
	return action;
};
